import React, {useContext} from "react";
import "./Pages.scss";
import { BuildingsContext } from "../../../bContext";

import menu from "../../../assets/menu_whole.PNG"
import menuEn from "../../../assets/menuWholeEn2.png"

function PageTwo() {
  const { switchToEnglish} = useContext(
    BuildingsContext
  );

  return (
    <>
    <div className="pageTwo">
      <div className="speech-bubble2">
      {switchToEnglish === false ? 
      <p className="first">
      Jeśli chcesz zobaczyć jak przebiega mechaniczne oczyszczanie ścieków,
      wybierz w menu dział <span>"Oczyszczalnia"</span>.
    </p>
    :
    <p className="first">
    If you want to see how mechanical wastewater treatment works, select the <span>"Treatment"</span> section in the menu.
  </p>  
    }
    {switchToEnglish === false ? 
        <p>
          Aby zobaczyć jak przebiega biologiczne oczyszczanie ścieków, kliknij w
          przycisk <span>"Osad czynny"</span>.
        </p>
        :
        <p>
       To see how biological wastewater treatment is carried out, click on the  
         <span> "active sediment" </span>  button.
      </p>
}
        {switchToEnglish === false ? 
      <p>
      Całość działającej oczyszczalni zobaczysz, po kliknięciu w przycisk{" "}
      <span>"Strona główna"</span>
    </p>
    :
    <p>
          You will see the entire plant in operation by clicking on the
          <span> "homepage" </span> button.
        </p>  
      }
        <div className="inner-triangle-right2"></div>
      </div>
      <div className="speech-bubble3">
  {switchToEnglish === false ? 
      <p className="first">
      Jeśli chcesz zobaczyć program wycieczki szkolnej, kliknij w dział
      <span>"Wycieczka"</span>.
    </p>
    :
    <p className="first">
If you want to see the school tour program click on the <span>"Tour"</span> section.
</p>    
}
        <div className="inner-triangle-right3"></div>
      </div>
      <div className="menu-pg2" style={{backgroundImage: !switchToEnglish ? `url(${menu})` : `url(${menuEn})`}}></div>

      <div>
        <div className="modal-header-ins"></div>
        <div className="modalbtn"></div>
        <div className="defaultbtn"></div>
      </div>
    </div>
    </>
  );
}

export default PageTwo;
